import { render } from "./MainView.vue?vue&type=template&id=df6d6c62"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src166128289/src/dakcess-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__